import React from 'react'
import { Card, Empty, Tag } from 'antd'
import Markdown from 'markdown-to-jsx'
import { formatDateTime } from './aicDashboardUtils'

/**
 * AIC 项目级数据字典（对应 t_vibe_project.database_readme_md，与 Vibe 应用同一字段）。
 * 只读展示：字典由 AIC Skill 生成并上传，看板不提供编辑入口。
 * Markdown 关闭原始 HTML 解析，避免字典内容注入脚本。
 */
export default function ProjectDictionary ({ item }) {
  const markdown = item && item.dataDictionaryMd ? String(item.dataDictionaryMd) : ''
  const syncedAt = item ? item.dataDictionarySyncedAt : null
  return <Card className="aic-panel" title="数据字典" extra={<Tag color="blue">只读</Tag>}>
    {markdown
      ? <div className="aic-description-grid">
        <span>同步时间</span><b>{formatDateTime(syncedAt, '-')}</b>
        <span>内容长度</span><b>{`${markdown.length} 字符`}</b>
      </div>
      : null}
    {markdown
      ? <div className="aic-dictionary-content">
        <Markdown options={{ disableParsingRawHTML: true }}>{markdown}</Markdown>
      </div>
      : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据字典，可使用 AIC Skill 生成并上传" />}
  </Card>
}
